import(/* webpackMode: "eager", webpackExports: ["PhoneNumberLogin"] */ "/workspace/web/src/features/auth/login/phone/components/PhoneNumberLogin/PhoneNumberLogin.tsx");
